import { CircleOptions } from "../../models/entities/organizations";

export function getGradientCircle(center: google.maps.LatLngLiteral, sliceSize: number): CircleOptions[]{
  const colors = [
    '#016206',
    '#05780a',
    '#018d0a',
    '#018d0a',
    '#00aa01',
    '#6bc062',
    '#6bc062'
  ];

  return colors.map((color, index) => {
    const circle = new CircleOptions(center, sliceSize * (index + 1));
    circle.strokeWeight = 0;
    circle.fillColor = color;
    circle.fillOpacity = 0.1;
    return circle;
  });
}